module.exports = __webpack_public_path__ + "src/assets/games/38/DARTS155.jpg";